var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28.003",
        height: "22.379",
        viewBox: "1291.519 298.198 28.003 22.379",
      },
    },
    [
      _c("g", { attrs: { "data-name": "🔍-Product-Icons" } }, [
        _c("g", { attrs: { "data-name": "ic_fluent_payment_24_filled" } }, [
          _c("path", {
            attrs: {
              d: "m1319.52 307.744.001 8.44c0 2.336-1.6 4.247-3.62 4.385l-.234.008h-20.293c-2.05 0-3.726-1.824-3.847-4.126l-.007-.268-.001-8.439h28.002Zm-5.235 5.601h-3.504l-.143.011c-.513.08-.908.581-.908 1.188s.395 1.108.908 1.187l.143.011h3.504l.143-.01c.513-.08.908-.581.908-1.188s-.395-1.108-.908-1.188l-.143-.01Zm1.382-15.147c2.05 0 3.726 1.824 3.847 4.127l.007.267v2.755h-28.002v-2.755c0-2.337 1.601-4.248 3.62-4.386l.235-.008h20.293Z",
              fill: "#92929b",
              "fill-rule": "evenodd",
              "data-name": "🎨-Color",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }